@if (!readonly) {
  @if (variant === 'DNI_NIE_PASSPORT') {
    <div class="field mb-2">
      <p-selectButton
        inputId="documentType"
        class="w-100"
        [options]="documentTypeOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="documentType()"
        (ngModelChange)="documentType.set($event)"
        aria-label="Document type">
      </p-selectButton>
    </div>
  }

  <input
    type="text"
    pInputText
    [ngModel]="internalValue"
    (ngModelChange)="updateChanges($event)"
    styleClass="w-100" />
} @else {
  <span>{{ internalValue }}</span>
}